import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { voteResultsService } from '../_services';
import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip'

class DeleteAllAnswersConfirmPage extends React.Component {
    render() {
        return (
            <div className="login col-md-6 col-md-offset-3">
                <h2 class="heading">Delete All Answers Confirm</h2>
                <form name="form" onSubmit={this.handleSubmit}>
                    <div className="form-group">
						<Link to="/results" className="btn btn-link" onClick={resetVotes}>Delete All Answers</Link>							
                    </div>
                    <div className="form-group">
                        <Link to="/results" className="btn btn-link">Cancel</Link>
                    </div>
                </form>
            </div>
        );
    }
}

function resetVotes(){
    voteResultsService.resetVotes().then(()=>{
        window.location.reload();
        toast("done!");
    },
    error => {
        toast("error!");
    })
}

function mapStateToProps(state) {
    const { registering } = state.registration;
    return {
        registering
    };
}

const connectedRegisterPage = connect(mapStateToProps)(DeleteAllAnswersConfirmPage);
export { connectedRegisterPage as DeleteAllAnswersConfirmPage };